import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '../assets/fenz-logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "header d-flex flex-row justify-content-between"
}
const _hoisted_2 = { class: "header__left d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo",
  src: _imports_0,
  alt: "Fire and Emergency NZ logo"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "header__nav d-flex flex-row align-self-end"
}
const _hoisted_5 = { class: "header__right d-none d-md-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "header__mobile-menu__line top" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "header__mobile-menu__line mid" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "header__mobile-menu__line bot" }, null, -1)
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 2,
  class: "header d-flex flex-row justify-content-between align-items-center"
}
const _hoisted_11 = { class: "header__report-left d-flex flex-row align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "header__report-close-text d-none d-md-block" }, "Close", -1)
const _hoisted_13 = { class: "header__report-title" }
const _hoisted_14 = { class: "header__report__print d-none d-md-flex justify-content-center align-items-center" }
const _hoisted_15 = { class: "header__report__print-text d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.showReportHeader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["header__button smart-status-button d-none d-md-flex align-self-end align-items-center", { 'active-tab': _ctx.currentRoute == 'SmartStatus' }]),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick('SmartStatus')))
                  }, " Smart Status ", 2),
                  _createElementVNode("button", {
                    class: _normalizeClass(["header__button icad-button d-none d-md-flex align-self-end align-items-center", { 'active-tab': _ctx.currentRoute == 'ICAD' }]),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick('ICAD')))
                  }, " ICAD Reporting ", 2)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "header__button signout-button d-none d-md-flex align-self-end align-items-center",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logoutRedirect()))
                }, " Sign Out "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "header__button signin-button d-none d-md-flex align-self-end align-items-center",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loginRedirect()))
                }, " Sign In "))
          ]),
          _createElementVNode("button", {
            class: _normalizeClass(["header__mobile-menu d-md-none", { open: _ctx.isMenuOpen }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleMenu()))
          }, _hoisted_9, 2)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showReportHeader)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["header__mobile-menu__content d-flex d-md-none flex-column", { open: _ctx.isMenuOpen }])
        }, [
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["header__button smart-status-button d-flex align-items-center", { 'active-tab': _ctx.currentRoute === 'SmartStatus' }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onClick('SmartStatus')))
              }, " Smart Status ", 2))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["header__button icad-button d-flex align-items-center", { 'active-tab': _ctx.currentRoute == 'ICAD' }]),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onClick('ICAD')))
              }, " ICAD Reporting ", 2))
            : _createCommentVNode("", true),
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "header__button signout-button d-flex align-items-center",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.logoutRedirect()))
              }, " Sign Out "))
            : (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "header__button signin-button d-flex align-items-center",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loginRedirect()))
              }, " Sign In "))
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.showReportHeader && _ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "header__report-close d-flex justify-content-center align-items-center",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleCloseReport()))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "times",
                class: "header__report-close-icon"
              }),
              _hoisted_12
            ]),
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.reportHeading), 1)
          ]),
          _createElementVNode("button", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.reportData.footerDownloadLabel), 1),
            _createVNode(_component_font_awesome_icon, {
              icon: "external-link-alt",
              class: "header__report__print-icon"
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}